import { call, put, takeEvery } from "redux-saga/effects";
import { RequestCleanFile, SuccessCleanFile, FailureCleanFile } from "../actions/cdrActions";
import { addNotification } from "../actions/notifierActions";

import axiosApi from "../../utils/axios";

export function* cleanFile({ payload }) {
  const { fileHash } = payload;
  try {
    yield call(axiosApi.post, `/api/cdr/clean-file/${fileHash}`);
    yield put(
      addNotification({ message: "Cleaned file successfully", options: { variant: "success" } }),
    );
    yield put(SuccessCleanFile(fileHash));
  } catch (e) {
    const errorMessage = e?.response?.data?.message || "";
    yield put(FailureCleanFile());
    yield put(
      addNotification({
        message: errorMessage === "CDR is not enabled" ? errorMessage : "Cleaning file failed",
        options: { variant: "error" },
        time: 3000,
      }),
    );
  }
}

const cdrSagas = [takeEvery(RequestCleanFile, cleanFile)];

export default cdrSagas;
